import script from "./InParens.vue?vue&type=script&setup=true&lang=ts"
export * from "./InParens.vue?vue&type=script&setup=true&lang=ts"

import "./InParens.vue?vue&type=style&index=0&id=76ecaeaa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76ecaeaa"]])

export default __exports__